import React, { useCallback, useEffect, useState } from 'react'
import useEventListener from './useEventListener'


const getElementInViewport = (el) => {
  if (!el) {
    console.warn('Element is null')
    return false
  }

  const rect = el.getBoundingClientRect()

  const viewportWidth   = window.innerWidth || document.documentElement.clientWidth
  const viewportHeight  = window.innerHeight || document.documentElement.clientHeight
  const isFitInViewport = el.offsetHeight < viewportHeight

  const isInAxisX = rect.left >= 0 && rect.right <= viewportWidth
  const isInAxisY = isFitInViewport ? (
    rect.top >= 0
    && rect.bottom <= viewportHeight
  ) : (
    rect.top <= 0
    && rect.bottom > 0
  )

  return isInAxisX && isInAxisY
}


// initialValue (true) is used for the element that already visible on the page
const useVisibility = (elementRef, initialValue) => {
  const [ isVisible, setIsVisible ] = useState(Boolean(initialValue))

  const handler = useCallback(() => {
    const isVisible = Boolean(elementRef.current) && getElementInViewport(elementRef.current)

    setIsVisible(isVisible)
  }, [ elementRef ])

  const removeScrollListener = useEventListener('scroll', handler)
  const removeResizeListener = useEventListener('resize', handler)

  const removeListeners = useCallback(() => {
    removeScrollListener()
    removeResizeListener()
  }, [ removeScrollListener, removeResizeListener ])

  useEffect(() => {
    const isVisible = Boolean(elementRef.current) && getElementInViewport(elementRef.current)

    setIsVisible(isVisible)
  }, [ elementRef, removeListeners ])

  return [ isVisible, removeListeners ]
}


export default useVisibility
